import { formatToCurrency } from "utils/currency";
import { ChevronDown } from "untitledui-js-base";
import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { VerifiedIncomeReport } from "types/landlord/reports";
import { createColumnHelper } from "@tanstack/react-table";
import { getDateRangeAndDiffByDocType, getIncomeSourceInfo } from "../utils";
import { cx } from "shared/utils";

const columnHelper =
  createColumnHelper<VerifiedIncomeReport["document"]["income_sources"][0]>();

export const verifiedIncomeSourceColumns = [
  columnHelper.accessor("employer", {
    header: "Income source",
    cell: ({ row }) => {
      const data = row.original;
      const incomeSource = getIncomeSourceInfo(data);
      const Icon = incomeSource.icon;
      return (
        <div className="flex gap-4 items-center">
          <Icon className="stroke-content-400" size="24" />
          <div className="flex flex-col gap-1 max-w-[180px]">
            <p className="text-content-1000 font-medium truncate">
              {incomeSource.title}
            </p>
            <p className="text-content-400 font-normal">
              {incomeSource.subtitle}
            </p>
          </div>
        </div>
      );
    }
  }),
  columnHelper.accessor("data-range" as any, {
    header: "Date range",
    cell: ({ row }) => {
      const data = row.original;
      const dateRange = getDateRangeAndDiffByDocType(data).dateRange;
      const dateDiff = getDateRangeAndDiffByDocType(data).humanReadableDiff;

      return (
        <div className="flex flex-col gap-2 text-left">
          <p className="text-content-1000">{dateRange}</p>
          <p className="text-content-400">{dateDiff}</p>
        </div>
      );
    }
  }),
  columnHelper.accessor("gross_monthly_income", {
    id: "right-align",
    header: "Gross monthly",
    size: 100,
    cell: ({ row }) => {
      const data = row.original.gross_monthly_income;
      return (
        <p className="text-content-500 text-sm font-medium text-end">
          {/* eslint-disable-next-line @typescript-eslint/no-unnecessary-condition */}
          {formatToCurrency({ cents: data?.cents, currency: data?.currency })}
        </p>
      );
    }
  }),
  columnHelper.accessor("net_monthly_income", {
    id: "right-align",
    header: "Net monthly",
    size: 100,
    cell: ({ row }) => {
      const data = row.original.net_monthly_income;
      return (
        <p className="text-content-500 text-sm font-medium text-end">
          {/* eslint-disable-next-line @typescript-eslint/no-unnecessary-condition */}
          {formatToCurrency({ cents: data?.cents, currency: data?.currency })}
        </p>
      );
    }
  }),
  columnHelper.accessor("expander" as any, {
    header: "",
    id: "fixed_width",
    size: 140,
    cell: ({ row }) => {
      return (
        row.getCanExpand() && (
          <Button
            variant={ButtonVariant.BASE}
            size={ButtonSize.SM}
            onClick={() => row.toggleExpanded()}
          >
            <div className="flex items-center gap-2">
              <ChevronDown
                className={cx(
                  "stroke-content-300",
                  row.getIsExpanded() ? "rotate-180 transition-all" : ""
                )}
                size="20"
              />
              {row.getIsExpanded() ? "Hide details" : "Show details"}
            </div>
          </Button>
        )
      );
    }
  })
];
